import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import Lookup from "./pages/Lookup";
import CardProfile from "./pages/CardProfile";
import Pitch from "./pages/Pitch";
import Activate from "./pages/Activate";
import ActivateComplete from "./pages/ActivateComplete";
import CardholderLogin from "./pages/CardholderLogin";
import CardholderRegister from "./pages/CardholderRegister";
import CardholderDashboard from "./pages/CardholderDashboard";
import CheckEmail from "./pages/CheckEmail";
import VerifyEmail from "./pages/VerifyEmail";
import MagicLogin from "./pages/MagicLogin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Privacy from "./pages/Privacy";
import RecoverEmail from "./pages/RecoverEmail";
import PrintFlyers from "./pages/PrintFlyers";
import PitchResidence from "./pages/PitchResidence";
import PitchCardTypes from "./pages/PitchCardTypes";
import PitchInvestors from "./pages/PitchInvestors";
import PitchPostnet from "./pages/PitchPostnet";
import VaultQrNew from "./pages/VaultQrNew";
import VaultQrScan from "./pages/VaultQrScan";
import VaultCardPreview from "./pages/VaultCardPreview";
import CheckpointCharlieScan from "./pages/CheckpointCharlieScan";
import CheckpointEnterprise from "./pages/CheckpointEnterprise";
import PostnetIssue from "./pages/PostnetIssue";
import CheckpointMintBind from "./pages/CheckpointMintBind";
import CheckpointCard from "./pages/CheckpointCard";
import Asset from "./pages/Asset";
import CardCompare from "./pages/CardCompare";
import TwinMatrix from "./pages/TwinMatrix";
import TwinMatrixScanner from "./pages/TwinMatrixScanner";
import DocumentUpload from "./pages/DocumentUpload";
import MyDocuments from "./pages/MyDocuments";
import WineBottle from "./pages/WineBottle";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/lookup" element={<Lookup />} />
            <Route path="/c/:code" element={<CardProfile />} />
            <Route path="/pitch" element={<Pitch />} />
            <Route path="/activate/complete" element={<ActivateComplete />} />
            <Route path="/activate/:code" element={<Activate />} />
            <Route path="/cardholder/login" element={<CardholderLogin />} />
            <Route path="/cardholder/register" element={<CardholderRegister />} />
            <Route path="/check-email" element={<CheckEmail />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/magic-login" element={<MagicLogin />} />
            <Route path="/my-cards" element={<CardholderDashboard />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/recover-email" element={<RecoverEmail />} />
            <Route path="/print-flyers/:code" element={<PrintFlyers />} />
            <Route path="/pitch/residence" element={<PitchResidence />} />
            <Route path="/pitch/card-types" element={<PitchCardTypes />} />
            <Route path="/pitch/investors" element={<PitchInvestors />} />
            <Route path="/pitch/postnet" element={<PitchPostnet />} />
            <Route path="/vault/new" element={<VaultQrNew />} />
            <Route path="/vault/scan" element={<VaultQrScan />} />
            <Route path="/cards/vault-preview" element={<VaultCardPreview />} />
            <Route path="/cc/scan" element={<CheckpointCharlieScan />} />
            <Route path="/cc/enterprise" element={<CheckpointEnterprise />} />
            <Route path="/cc/postnet" element={<PostnetIssue />} />
            <Route path="/cc/mint/:code" element={<CheckpointMintBind />} />
            <Route path="/checkpoint/:cardCode" element={<CheckpointCard />} />
            <Route path="/a/:assetCode" element={<Asset />} />
            <Route path="/wine/:code" element={<WineBottle />} />
            <Route path="/matrix/:assetCode" element={<TwinMatrixScanner />} />
            <Route path="/dmx/:assetCode" element={<TwinMatrixScanner />} />
            <Route path="/cards" element={<CardCompare />} />
            <Route path="/twin-matrix" element={<TwinMatrix />} />
            <Route path="/documents" element={<MyDocuments />} />
            <Route path="/documents/new" element={<DocumentUpload />} />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
